import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Marquee from "react-fast-marquee";
import CardImage from "../../components/images/car.png";
import VectorImage from "../../components/images/vector.png";
import { v4 } from "uuid";

const useStyles = makeStyles({
    root: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        height: "35px",
        padding: 5,
        backgroundColor: "#000000",
        zIndex: 1500,
        display: 'flex'
    },
    triangleTopLeft: {
        width: 0,
        height: 0,
        borderTop: "36px solid #FF6A6A",
        borderRight: "25px solid #000000",
    },
    vehicleStatus: {
        backgroundColor: '#FF6A6A',
        display: 'flex',
        paddingLeft: '15px'
    },
    rectangle: {
        display: 'flex',
    },
    text: {
        color: '#FFFFFF',
        fontSize: '12px',
        textAlign: 'center'
    },
    textColor: {
        color: '#FFFFFF',
        fontSize: '12px',
        textTransform:'uppercase'
    },
    numberCard: {
        color: '#FFFFFF',
        fontSize: '13px',
        width: '22px',
        height: '20px',
        backgroundColor: '#003FAF',
        justifyContent: 'center',
        display: 'flex',
    },
    vector: {
        width: '15px',
        height: '15px',
        marginLeft: '15px',
    },
    vector2: {
        width: '15px',
        height: '15px'
    },
    carImage: {
        width: '40px',
        height: '15px',
        marginLeft: '20px',
    }
});


export default function VehicleStatusCount(props:any) {
    const {AllVehicleStatusCount} =props;
    const classes = useStyles();
    return (
        <>
            <footer className={classes.root}>
                <div className={classes.rectangle}>
                    <div className={classes.vehicleStatus}>
                        <span className={classes.text}>
                            ALL VEHICLE STATUS</span>
                        <div className={classes.triangleTopLeft} />
                    </div>
                </div>
                <div>
                </div>
                <Marquee speed={50}>
                    {AllVehicleStatusCount?.map((item: any,index:any) => {
                        return <Grid
                            container
                            direction="row"
                            alignItems="center"
                            className="global-footer"
                            key={index}
                        >
                            <Grid item xs={12}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <span className={classes.textColor}>
                                        {item.Name} &nbsp;
                                    </span>
                                    <span
                                        className={classes.numberCard}
                                    >{item.Count}</span>
                                    <img
                                        className={classes.vector}
                                        alt="vector"
                                        src={VectorImage}
                                    />&nbsp;
                                    <img
                                        className={classes.vector2}
                                        alt="vector"
                                        src={VectorImage}
                                    />
                                    <img
                                        className={classes.carImage}
                                        alt="CarLogo"
                                        src={CardImage}
                                    />&nbsp;
                                </div>
                            </Grid>
                        </Grid>
                    })}
                </Marquee>
            </footer >
        </>
    );
}
